import styled from 'styled-components';
import { TextField } from '@material-ui/core';

export const DateInput = styled(TextField)`
  margin: 20px 24px 20px 0;
`;

export const LinkInput = styled(TextField)`
  margin: 20px 0;
  width: 54%;
`;
